import { ReactNode } from "react";
import { SlCamera, SlCheck, SlClock, SlEmotsmile, SlPeople, SlRocket, SlVolumeOff  } from "react-icons/sl";
import { TbMeat, TbPlantOff, TbShirt } from "react-icons/tb";
import { useMediaQuery } from "react-responsive";

export const ImportantInfo = () => {
    const isSmallScreen = useMediaQuery({ query: `(max-width: 768px)` });
    return (
        <section className="w-full px-8 pb-4 bg-gray-200">
            <h2 className="amatic-sc-bold text-4xl text-center pt-4">Informações importantes</h2>
            <ul className={`md:w-3/6 w-full mt-2 mx-auto flex flex-wrap`}>
                <Info icon={<SlCheck />} info="Confirme sua presença" />
                <Info icon={<SlEmotsmile />} info="Seja educado" />
                <Info icon={<TbMeat />} info="Aproveite o buffet" />
                <Info icon={<SlRocket />} info="Não saia sem se despedir" />
                <Info icon={<SlPeople />} info="Convidado não convida" />
                <Info icon={<SlClock />} info="Não se atrase" />
                <Info icon={<SlVolumeOff />} info="Não faça comentários negativos" />
                <Info icon={<SlCamera />} info="Não atrapalhe o fotógrafo" />
                <Info icon={<TbPlantOff />} info="Não leve a decoração para casa" />
                <Info icon={<TbShirt />} info="Traje esporte fino e lembre-se de não ir de branco, off ou bege" />
            </ul>
        </section>
    )
}

type InfoProps = {
    icon: ReactNode,
    info: string;
}

const Info = ({icon, info}: InfoProps) => {
    return (
        <li className={`poppins-light text-lg w-full md:w-1/2 flex items-center gap-2 p-1`}>
            <span className="">{icon}</span>
            <p>{info}</p>
        </li>
    )
}